import { memo, useContext } from 'react';

import { FormContext } from './utils';
import { Button } from '../buttons';
import type { ButtonProps } from '../buttons/utils';

/**
 * Пропсы кнопки сброса формы: базовые пропсы Button, кроме `onClick` —
 * он перекрывается внутренним (onClick={handleReset}).
 */
export type ResetButtonProps = Omit<ButtonProps, 'onClick'>;

const ResetButton = (props: ResetButtonProps) => {
  // FormContext из utils.js: при allowJs:false useContext возвращает unknown,
  // приводим к ожидаемой форме (Provider подаёт Formik-контекст).
  const { isSubmitting, handleReset } = useContext(FormContext) as {
    isSubmitting?: boolean;
    handleReset: any;
  };
  const {
    type = 'reset', variant = 'outline-primary', disabled, className, children, ...rest
  } = props;

  return (
    <Button
      { ...rest }
      type={ type }
      variant={ variant }
      disabled={ disabled || isSubmitting }
      className={ `btn ${ className }` }
      onClick={ handleReset }
    >
      { children }
    </Button>
  );
};

export default memo(ResetButton);
